<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Campaign Details</a>
      </nav>
    </div>
    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-12">
                                    <span class="lead-title" v-if="GetCampaignDetails.broker_name">{{GetCampaignDetails.broker_name}}</span>
                                    <span class="sub-title" v-if="GetCampaignDetails.firm_name">{{GetCampaignDetails.firm_name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                          <div class="row">
                              <div class="col-12">
                                <span class="enq-title">Project Name</span>
                                <span class="enq-details">{{GetCampaignDetails.project_name}}</span>
                              </div>
                          </div>
                            <div class="row">
                                <div class="col-6">
                                    <span class="enq-title">Broker</span>
                                    <span class="enq-details">{{GetCampaignDetails.broker_name}} - {{GetCampaignDetails.firm_name}}</span>
                                </div>
                                  <div class="col-6" v-if="GetCampaignDetails.broker_categorization">
                                    <span class="enq-title">Categorization</span>
                                    <span class="enq-details">{{GetCampaignDetails.broker_categorization}}</span>
                                </div>
                                  <div class="col-6" v-if="GetCampaignDetails.field_executive">
                                    <span class="enq-title">Field Executive</span>
                                    <span class="enq-details">{{GetCampaignDetails.field_executive}}</span>
                                </div>
                                <div class="col-6" v-if="GetCampaignDetails.campaign_type">
                                    <span class="enq-title">Campaign Type</span>
                                    <span class="enq-details">{{GetCampaignDetails.campaign_type}}</span>
                                </div>
                                <div class="col-6" v-if="GetCampaignDetails.title">
                                    <span class="enq-title">Title</span>
                                    <span class="enq-details">{{GetCampaignDetails.title}}</span>
                                </div>
                                <div class="col-6" v-if="GetCampaignDetails.executed">
                                    <span class="enq-title">Status</span>
                                    <span class="enq-details">{{GetCampaignDetails.executed}}</span>
                                </div>
                                <div class="col-6" v-if="GetCampaignDetails.start_date">
                                    <span class="enq-title">Start Date</span>
                                    <span class="enq-details">{{GetCampaignDetails.start_date}}</span>
                                </div>
                                  <div class="col-6" v-if="GetCampaignDetails.end_date">
                                    <span class="enq-title">End Date</span>
                                    <span class="enq-details">{{GetCampaignDetails.end_date}}</span>
                                </div>
                                <div class="col-12" v-if="GetCampaignDetails.comment">
                                    <span class="enq-title">Comment</span>
                                    <read-more class="campaign-comment" more-str="read more"  :text="GetCampaignDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                </div>

                            </div>
                        </div>
                       <div class="card-footer p-2">
                            <div class="row">
                                 <div class="col-12">
                                    <span class="lead-heading">Outreach</span>
                                </div>
                                <div class="col-3">
                                    <span class="enq-title">Planned</span>
                                    <span class="enq-details">{{GetCampaignDetails.compaign_data}}</span>
                                </div>
                                <div class="col-4">
                                     <span class="enq-title">Achieved</span>
                                    <span class="enq-details">{{GetCampaignDetails.achieved}}</span>
                                </div>
                                 <div class="col-5">
                                     <span class="enq-title">Enquiries/Hot</span>
                                    <span class="enq-details">{{GetCampaignDetails.enquiries_count}}</span>
                                </div>
                            </div>
                        </div>
                      <div class="card-btn">
                    <div class="row">
                      <div class="col-12 mt-3 mb-3">
                        <router-link  :to="{ name: 'EditCampaign', params: { campaign_id: queryP.campaign_id }}" class="btn btn-primary btn-block"> <img
                             alt="" class="m-fix mr-1" /> Edit
                          Campaign</router-link>
                      </div>
                    </div>
                  </div>
                </div>   
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CampaignDetails',
  data() {
    return {
      queryP: {},
      GetCampaignDetails: {},
    }
  },
  mounted () {
    this.FetchCampaignDetails()
  },
  methods: {
    FetchCampaignDetails() {
    this.queryP['campaign_id'] = this.$route.params.id;
    this.$axios.get(`buildings/broker_campaign_details`, { params: this.queryP }).then((res) => {
        this.GetCampaignDetails = JSON.parse(JSON.stringify(res.data).substring(1, JSON.stringify(res.data).length-1));
        if (this.GetCampaignDetails.executed === true || this.GetCampaignDetails.executed === 'true') {
          this.GetCampaignDetails.executed = 'Executed'
        } else {
          this.GetCampaignDetails.executed = 'Not-Executed'
        }
      });
    }
  }
}
</script>
<style scoped>
.inner-page{
    margin-top: 60px;
}
.campaign-comment{
    white-space: pre-line;
}
</style>